module.exports = __webpack_public_path__ + "static/media/Ladies Storm Hackathons Meet-Up.6a895cfa.png";